import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/en"; // or 'ne' for Nepali if needed

dayjs.extend(localizedFormat);
dayjs.locale("en");

export default dayjs;
